import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import HomePage from '@/components/HomePage'
import Category from '@/components/Category'
import DetailPaket from '@/components/Home/DetailPaket'
import store from '../store/index.js'
// import Front from '@/components/Front'

import Referral from '@/components/Referral'
/*-------ADMIN-------*/
import AdminProfileSettings from '@/components/Admin/ProfileSettings'
import AdminRefHome from '@/components/Admin/RefHome'
import AdminRefTingkatan from '@/components/Admin/RefTingkatan'
import AdminMateri from '@/components/Admin/Materi'
import AdminTryout from '@/components/Admin/Tryout'
import AdminTryoutSoal from '@/components/Admin/Tryout/Soal'
import AdminTryoutTrySoal from '@/components/Admin/Tryout/Try'
import AdminTryoutPembahasan from '@/components/Admin/Tryout/Pembahasan'
import AdminKelasSaya from '@/components/Admin/KelasSaya'
import AdminBimbel from '@/components/Admin/Bimbel'
import AdminPenjualan from '@/components/Admin/Penjualan'
import AdminLaporsoal from '@/components/Admin/Laporsoal'
import AdminUser from '@/components/Admin/User'
import AdminWallet from '@/components/Admin/Wallet'
import AdminRank from '@/components/Admin/Rank'
import AdminRankPaket from '@/components/Admin/RankPaket'
import AdminPaketBelajarInvoice from '@/components/Admin/PaketBelajar/Invoice'
import AdminPaketBelajarInvoiceGratis from '@/components/Admin/PaketBelajar/InvoiceGratis'
import AdminKeuangan from '@/components/Admin/Keuangan'
import AdminGiveaway from '@/components/Admin/Giveaway'

//-------------------------------------------------------------


/*-------Siswa-------*/
import SiswaProfileSettings from '@/components/Siswa/ProfileSettings'
import SiswaPaketBelajar from '@/components/Siswa/PaketBelajar'
import SiswaPaketBelajarDetail from '@/components/Siswa/PaketBelajar/Detail'
import SiswaPaketBelajarSummaryCheckout from '@/components/Siswa/PaketBelajar/SummaryCheckout'
import SiswaPaketBelajarInvoice from '@/components/Siswa/PaketBelajar/Invoice'
import SiswaPaketBelajarInvoiceGratis from '@/components/Siswa/PaketBelajar/InvoiceGratis'
import SiswaTransaksi from '@/components/Siswa/Transaksi'
import SiswaPaketSaya from '@/components/Siswa/PaketSaya'
import SiswaPaketSayaDetail from '@/components/Siswa/PaketSaya/Detail'
import SiswaTryoutTrySoal from '@/components/Siswa/Tryout/Try'
import SiswaTryoutPembahasan from '@/components/Siswa/Tryout/Pembahasan'
import SiswaLearnDoTeach from '@/components/Siswa/LearnDoTeach'
import SiswaLearnDoTeachSoal from '@/components/Siswa/LearnDoTeach/Soal'
import SiswaWallet from '@/components/Siswa/Wallet'
import MitraPenjualan from '@/components/Siswa/Penjualan'

//-------------------------------------------------------------


import InstructorProfileSettings from '@/components/Instructor/ProfileSettings'
// import InstructorDashboard from '@/components/Instructor/Dashboard'
// import Appointments from '@/components/Instructor/Appointments'
// import Instructors from '@/components/School/Instructors'
// import InstructorProfile from '@/components/Instructor/InstructorProfile'
// import InstructorChat from '@/components/Instructor/Chat'
import InstructorInstansi from '@/components/Instructor/Instansi'
import InstructorRekamJejak from '@/components/Instructor/RekamJejak'
// import InstructorRefTingkatan from '@/components/Instructor/RefTingkatan'
import InstructorMateri from '@/components/Instructor/Materi'
import InstructorTryout from '@/components/Instructor/Tryout'
import InstructorTryoutSoal from '@/components/Instructor/Tryout/Soal'
import InstructorTryoutTrySoal from '@/components/Instructor/Tryout/Try'
import InstructorTryoutPembahasan from '@/components/Instructor/Tryout/Pembahasan'
import InstructorKelasSaya from '@/components/Instructor/KelasSaya'
import InstructorPenugasan from '@/components/Instructor/Penugasan'
import InstructorWallet from '@/components/Instructor/Wallet'

//-------------------------------------------------------------



// import Reviews from '@/components/School/Reviews'
// import SocialMedia from '@/components/School/SocialMedia'
import InstructorRegister from '@/components/Instructor/Register'
import InstructorChangePassword from '@/components/Instructor/ChangePassword'
// import MapGrid from '@/components/School/MapGrid'
// import MapList from '@/components/School/MapList'
// import SearchSchool from '@/components/School/Search'
// import SchoolProfile from '@/components/School/SchoolProfile'
// import SchoolDashboard from '@/components/School/Dashboard'
// import ScheduleTiming from '@/components/School/ScheduleTiming'
// import Booking from '@/components/School/Booking'
// import Checkout from '@/components/School/Checkout'
// import BookingSuccess from '@/components/School/BookingSuccess'
// import Invoices from '@/components/School/Invoices'
// import InvoiceView from '@/components/School/Invoices/View'
// import SchoolProfileSettings from '@/components/School/ProfileSettings'
import SchoolChangePassword from '@/components/School/ChangePassword'
// import CourseList from '@/components/Course/List'
// import CourseDetails from '@/components/Course/Details'
// import VoiceCall from '@/components/Pages/VoiceCall'
// import VideoCall from '@/components/Pages/VideoCall'
// import Calendar from '@/components/Pages/Calendar'
// import Components from '@/components/Pages/Components'
// import StarterPage from '@/components/Pages/StarterPage'
import Login from '@/components/Pages/Login'
import SchoolRegister from '@/components/Pages/Register'
import ForgotPassword from '@/components/Pages/ForgotPassword'
import BlogList from '@/components/Blog/BlogList'
import BlogGrid from '@/components/Blog/BlogGrid'
import BlogDetails from '@/components/Blog/BlogDetails'
import TermsandConditions from '@/components/TermsandConditions'
import PrivacyPolicy from '@/components/PrivacyPolicy'

Vue.use(Router)

// export default new Router({
//   mode: 'history',
//   base: 'school',
//   routes: [
//     {
//       path: '/',
//       name: 'home',
//       component: Home
//     },
//     {
//       path: '/index',
//       name: 'home-index',
//       component: Home
//     },
//     {
//       path: '/instructor/dashboard',
//       name: 'instructor-dashboard',
//       component: InstructorDashboard
//     },
//     {
//       path: '/instructor/appointments',
//       name: 'instructor-appointments',
//       component: Appointments
//     },
//     {
//       path: '/instructors',
//       name: 'instructors',
//       component: Instructors
//     },
//     {
//       path: '/instructor/profile',
//       name: 'instructor-profile',
//       component: InstructorProfile
//     },
//     {
//       path: '/instructor/chat',
//       name: 'instructor-chat',
//       component: InstructorChat
//     },
//     {
//       path: '/instructor/profile-settings',
//       name: 'instructor-profile-settings',
//       component: InstructorProfileSettings
//     },
//     {
//       path: '/instructor/reviews',
//       name: 'instructor-reviews',
//       component: Reviews
//     },
//     {
//       path: '/social-media',
//       name: 'school-social-media',
//       component: SocialMedia
//     },
//     {
//       path: '/instructor/register',
//       name: 'instructor-register',
//       component: InstructorRegister
//     },
//     {
//       path: '/instructor/change-password',
//       name: 'instructor-change-password',
//       component: InstructorChangePassword
//     },
//     {
//       path: '/map-grid',
//       name: 'map-grid',
//       component: MapGrid
//     },
//     {
//       path: '/map-list',
//       name: 'map-list',
//       component: MapList
//     },
//     {
//       path: '/search',
//       name: 'search-school',
//       component: SearchSchool
//     },
//     {
//       path: '/profile',
//       name: 'school-profile',
//       component: SchoolProfile
//     },
//     {
//       path: '/dashboard',
//       name: 'school-dashboard',
//       component: SchoolDashboard
//     },
//     {
//       path: '/schedule-timings',
//       name: 'schedule-timings',
//       component: ScheduleTiming
//     },
//     {
//       path: '/booking',
//       name: 'booking',
//       component: Booking
//     },
    // {
    //   path: '/checkout',
    //   name: 'checkout',
    //   component: Checkout
    // },
//     {
//       path: '/booking-success',
//       name: 'booking-success',
//       component: BookingSuccess
//     },
//     {
//       path: '/invoices',
//       name: 'invoices',
//       component: Invoices
//     },
//     {
//       path: '/profile-settings',
//       name: 'school-profile-settings',
//       component: SchoolProfileSettings  
//     },
//     {
//       path: '/change-password',
//       name: 'school-change-password',
//       component: SchoolChangePassword  
//     },
//     {
//       path: '/course',
//       name: 'course-list',
//       component: CourseList  
//     },
//     {
//       path: '/course/details',
//       name: 'course-details',
//       component: CourseDetails  
//     },
//     {
//       path: '/voice-call',
//       name: 'voice-call',
//       component: VoiceCall  
//     },
//     {
//       path: '/video-call',
//       name: 'video-call',
//       component: VideoCall  
//     },
//     {
//       path: '/calendar',
//       name: 'calendar',
//       component: Calendar  
//     },
//     {
//       path: '/components',
//       name: 'components',
//       component: Components  
//     },
//     {
//       path: '/invoice/view',
//       name: 'invoice-view',
//       component: InvoiceView  
//     },
//     {
//       path: '/blank-page',
//       name: 'starter-page',
//       component: StarterPage  
//     },
//     {
//       path: '/login',
//       name: 'login-page',
//       component: Login  
//     },
//     {
//       path: '/register',
//       name: 'register-page',
//       component: SchoolRegister  
//     },
//     {
//       path: '/forgot-password',
//       name: 'forgot-password',
//       component: ForgotPassword  
//     },
//     {
//       path: '/blog/list',
//       name: 'blog-list',
//       component: BlogList  
//     },
//     {
//       path: '/blog/grid',
//       name: 'blog-grid',
//       component: BlogGrid 
//     },
//     {
//       path: '/blog/details',
//       name: 'blog-details',
//       component: BlogDetails 
//     },
//     {
//       path: '/term-condition',
//       name: 'term-condition',
//       component: TermsandConditions 
//     },
//     {
//       path: '/privacy-policy',
//       name: 'privacy-policy',
//       component: PrivacyPolicy 
//     }
//   ]
// })

const routes= [
  // {
  //   path: '/front',
  //   name: 'frontPage',
  //   component: Front
  // },
  // {
  //   path: '/',
  //   name: 'homePage',
  //   component: HomePage
  // },
  {
    path: '/',
    name: 'home',
    component: Home
    // name: 'login-page',
    // component: Login
  },
  {
    path: '/index',
    name: 'home-index',
    component: Home    
    // name: 'login-page',
    // component: Login
    
  },
  {
    path: '/category',
    name: 'category',
    component: Category ,
    props: (route) => ({ name: route.query.idcat })      
  },
  {
    path: '/home/detail-paket',
    name: 'home-detail-paket',
    component: DetailPaket      
  },
  {
    path: '/referral',
    name: 'referral',
    component: Referral,
    props: (route) => ({ name: route.query.koderef })
  },

  /*--------ADMIN--------- */
  {
    path: '/admin/profile-settings',
    name: 'admin-profile-settings',
    component: AdminProfileSettings
  },
  {
    path: '/admin/ref-home',
    name: 'admin-ref-home',
    component: AdminRefHome
  },
  {
    path: '/admin/ref-tingkatan',
    name: 'admin-ref-tingkatan',
    component: AdminRefTingkatan
  },
  {
    path: '/admin/materi',
    name: 'admin-materi',
    component: AdminMateri
  },
  {
    path: '/admin/tryout',
    name: 'admin-tryout',
    component: AdminTryout
  },
  {
    path: '/admin/tryout/soal',
    name: 'admin-tryout-soal',
    component: AdminTryoutSoal
  },
  {
    path: '/admin/tryout/try',
    name: 'admin-tryout-try',
    component: AdminTryoutTrySoal
  },
  {
    path: '/admin/tryout/pembahasan',
    name: 'admin-tryout-pembahasan',
    component: AdminTryoutPembahasan
  },
  {
    path: '/admin/kelas-saya',
    name: 'admin-kelas-saya',
    component: AdminKelasSaya
  },
  {
    path: '/admin/bimbel',
    name: 'admin-bimbel',
    component: AdminBimbel
  },
  {
    path: '/admin/user',
    name: 'admin-user',
    component: AdminUser
  },
  {
    path: '/admin/penjualan',
    name: 'admin-penjualan',
    component: AdminPenjualan
  },  
  {
    path: '/mitra/penjualan',
    name: 'mitra-penjualan',
    component: MitraPenjualan
  },  
  {
    path: '/admin/wallet',
    name: 'admin-wallet',
    component: AdminWallet
  },
  {
    path: '/admin/laporsoal',
    name: 'admin-laporsoal',
    component: AdminLaporsoal
  },  
  {
    path: '/admin/rank',
    name: 'admin-rank',
    component: AdminRank
  },  
  {
    path: '/admin/rank-paket',
    name: 'admin-rank-paket',
    component: AdminRankPaket
  }, 
  {
    path: '/admin/paket-belajar-invoice',
    name: 'admin-paket-belajar-invoice',
    component: AdminPaketBelajarInvoice
  },
  {
    path: '/admin/paket-belajar-invoice-gratis',
    name: 'admin-paket-belajar-invoice-gratis',
    component: AdminPaketBelajarInvoiceGratis
  },
  {
    path: '/admin/keuangan',
    name: 'admin-keuangan',
    component: AdminKeuangan
  }, 
  {
    path: '/admin/giveaway',
    name: 'admin-giveaway',
    component: AdminGiveaway
  },

  // -----------------------------------

  
  /*--------SISWA--------- */
  {
    path: '/siswa/profile-settings',
    name: 'siswa-profile-settings',
    component: SiswaProfileSettings
  },
  {
    path: '/siswa/paket-belajar',
    name: 'siswa-paket-belajar',
    component: SiswaPaketBelajar
  },
  {
    path: '/siswa/paket-belajar-detail',
    name: 'siswa-paket-belajar-detail',
    component: SiswaPaketBelajarDetail
  },
  {
    path: '/siswa/paket-belajar-summmarycheckout',
    name: 'siswa-paket-belajar-summmarycheckout',
    component: SiswaPaketBelajarSummaryCheckout
  },
  {
    path: '/siswa/paket-belajar-invoice',
    name: 'siswa-paket-belajar-invoice',
    component: SiswaPaketBelajarInvoice
  },
  {
    path: '/siswa/paket-belajar-invoice-gratis',
    name: 'siswa-paket-belajar-invoice-gratis',
    component: SiswaPaketBelajarInvoiceGratis
  },
  {
    path: '/siswa/transaksi',
    name: 'siswa-transaksi',
    component: SiswaTransaksi
  },
  {
    path: '/siswa/paket-saya',
    name: 'siswa-paket-saya',
    component: SiswaPaketSaya
  },
  {
    path: '/siswa/paket-saya-detail',
    name: 'siswa-paket-saya-detail',
    component: SiswaPaketSayaDetail
  },
  {
    path: '/siswa/tryout/try',
    name: 'siswa-tryout-try',
    component: SiswaTryoutTrySoal
  },
  {
    path: '/siswa/tryout/pembahasan',
    name: 'siswa-tryout-pembahasan',
    component: SiswaTryoutPembahasan
  },
  {
    path: '/siswa/learndoteach',
    name: 'siswa-learndoteach',
    component: SiswaLearnDoTeach
  },
  {
    path: '/siswa/learndoteach/soal',
    name: 'siswa-learndoteach-soal',
    component: SiswaLearnDoTeachSoal
  },
  {
    path: '/siswa/wallet',
    name: 'siswa-wallet',
    component: SiswaWallet
  },
  
  // -----------------------------------
 
  {
    path: '/instructor/profile-settings',
    name: 'instructor-profile-settings',
    component: InstructorProfileSettings
  },
  // {
  //   path: '/instructor/dashboard',
  //   name: 'instructor-dashboard',
  //   component: InstructorDashboard
  // },
  // {
  //   path: '/instructor/appointments',
  //   name: 'instructor-appointments',
  //   component: Appointments
  // },
  // {
  //   path: '/instructors',
  //   name: 'instructors',
  //   component: Instructors
  // },
  // {
  //   path: '/instructor/profile',
  //   name: 'instructor-profile',
  //   component: InstructorProfile
  // },
  // {
  //   path: '/instructor/chat',
  //   name: 'instructor-chat',
  //   component: InstructorChat
  // },
  
  {
    path: '/instructor/instansi',
    name: 'instructor-instansi',
    component: InstructorInstansi
  },
  {
    path: '/instructor/rekam-jejak',
    name: 'instructor-rekam-jejak',
    component: InstructorRekamJejak
  },
  // {
  //   path: '/instructor/ref-tingkatan',
  //   name: 'instructor-ref-tingkatan',
  //   component: InstructorRefTingkatan
  // },  
  {
    path: '/instructor/materi',
    name: 'instructor-materi',
    component: InstructorMateri
  },
  {
    path: '/instructor/tryout',
    name: 'instructor-tryout',
    component: InstructorTryout
  },
  {
    path: '/instructor/tryout/soal',
    name: 'instructor-tryout-soal',
    component: InstructorTryoutSoal
  },
  {
    path: '/instructor/tryout/try',
    name: 'instructor-tryout-try',
    component: InstructorTryoutTrySoal
  },  
  {
    path: '/instructor/tryout/pembahasan',
    name: 'instructor-tryout-pembahasan',
    component: InstructorTryoutPembahasan
  },
  {
    path: '/instructor/kelas-saya',
    name: 'instructor-kelas-saya',
    component: InstructorKelasSaya
  },
  {
    path: '/instructor/penugasan',
    name: 'instructor-penugasan',
    component: InstructorPenugasan
  },
  {
    path: '/instructor/wallet',
    name: 'instructor-wallet',
    component: InstructorWallet
  },
  // {
  //   path: '/instructor/reviews',
  //   name: 'instructor-reviews',
  //   component: Reviews
  // },
  // {
  //   path: '/social-media',
  //   name: 'school-social-media',
  //   component: SocialMedia
  // },
  {
    path: '/instructor/register',
    name: 'instructor-register',
    component: InstructorRegister
  },
  {
    path: '/instructor/change-password',
    name: 'instructor-change-password',
    component: InstructorChangePassword
  },
  // {
  //   path: '/map-grid',
  //   name: 'map-grid',
  //   component: MapGrid
  // },
  // {
  //   path: '/map-list',
  //   name: 'map-list',
  //   component: MapList
  // },
  // {
  //   path: '/search',
  //   name: 'search-school',
  //   component: SearchSchool
  // },
  // {
  //   path: '/profile',
  //   name: 'school-profile',
  //   component: SchoolProfile
  // },
  // {
  //   path: '/dashboard',
  //   name: 'school-dashboard',
  //   component: SchoolDashboard
  // },
  // {
  //   path: '/schedule-timings',
  //   name: 'schedule-timings',
  //   component: ScheduleTiming
  // },
  // {
  //   path: '/booking',
  //   name: 'booking',
  //   component: Booking
  // },
  // {
  //   path: '/checkout',
  //   name: 'checkout',
  //   component: Checkout
  // },
  // {
  //   path: '/booking-success',
  //   name: 'booking-success',
  //   component: BookingSuccess
  // },
  // {
  //   path: '/invoices',
  //   name: 'invoices',
  //   component: Invoices
  // },
  // {
  //   path: '/profile-settings',
  //   name: 'school-profile-settings',
  //   component: SchoolProfileSettings  
  // },
  {
    path: '/change-password',
    name: 'school-change-password',
    component: SchoolChangePassword  
  },
  // {
  //   path: '/course',
  //   name: 'course-list',
  //   component: CourseList  
  // },
  // {
  //   path: '/course/details',
  //   name: 'course-details',
  //   component: CourseDetails  
  // },
  // {
  //   path: '/voice-call',
  //   name: 'voice-call',
  //   component: VoiceCall  
  // },
  // {
  //   path: '/video-call',
  //   name: 'video-call',
  //   component: VideoCall  
  // },
  // {
  //   path: '/calendar',
  //   name: 'calendar',
  //   component: Calendar  
  // },
  // {
  //   path: '/components',
  //   name: 'components',
  //   component: Components  
  // },
  // {
  //   path: '/invoice/view',
  //   name: 'invoice-view',
  //   component: InvoiceView  
  // },
  // {
  //   path: '/blank-page',
  //   name: 'starter-page',
  //   component: StarterPage  
  // },
  {
    path: '/login',
    name: 'login-page',
    component: Login  
  },
  {
    path: '/register',
    name: 'register-page',
    component: SchoolRegister  
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword  
  },
  {
    path: '/blog/list',
    name: 'blog-list',
    component: BlogList  
  },
  {
    path: '/blog/grid',
    name: 'blog-grid',
    component: BlogGrid 
  },
  {
    path: '/blog/details',
    name: 'blog-details',
    component: BlogDetails 
  },
  {
    path: '/term-condition',
    name: 'term-condition',
    component: TermsandConditions 
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: PrivacyPolicy 
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL, //'pejuang-pendidik',//
  routes,
  // scrollBehavior(to, from, savedPosition) {
  //   // always scroll to top
  //   return { top: 0 }
  // },
  // scrollBehavior(to, from, savedPosition) {
  //     if (to.hash) {
  //         return {el: to.hash, behavior: "smooth"};
  //     } else if (savedPosition) {
  //         return savedPosition;
  //     } else {
  //         const isLoaded = () => (document.readyState === _STATE) && clearInterval(interval);
  //         const scrollTo = () => window.scrollTo({top: 0, left: 0, behavior: 'smooth'});

  //         interval = setInterval(() => hasLoaded() && scrollTo(), timer);
  //     }
  // }
}) 


router.beforeEach((to, from, next) => { 
  document.body.scrollTop = 0;
  // window.scrollTo(0, 0);
  // document.documentElement.scrollTop = 0;

  if (to.matched.some(record => record.meta.auth)) {
    if (store.getters.isLoggedIn && store.getters.user) {
      next()
      return
    }
    next('/login')
  }

  if (to.matched.some(record => record.meta.guest)) {
    if (!store.getters.isLoggedIn) {
      next()
      return
    }
    next('/instructor/profile')
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js